import { render, staticRenderFns } from "./SelectTaxVatIn.vue?vue&type=template&id=0c806613&"
import script from "./SelectTaxVatIn.vue?vue&type=script&lang=ts&"
export * from "./SelectTaxVatIn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c806613')) {
      api.createRecord('0c806613', component.options)
    } else {
      api.reload('0c806613', component.options)
    }
    module.hot.accept("./SelectTaxVatIn.vue?vue&type=template&id=0c806613&", function () {
      api.rerender('0c806613', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tax/SelectTaxVatIn.vue"
export default component.exports